import {CenterHero, TicketHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";
import {Proposer} from "../../blocks/proposer/Proposer";
import {useEffect} from "react";
import {DetailedEvents, Events} from "../../blocks/events/Events";
import {PrimaryButton} from "../../components/button/Button";
import {API, Entities} from "../../utils/Api";
import {useLoaderData} from "react-router-dom";

export default function EventsPage(){
    const data = useLoaderData();
    var events = data.events;
    var invidualEvents=events.filter((event)=>{return event.presenters.length===1});
    var teamEvents=events.filter((event)=>{return event.presenters.length>1});
    var eventsByCategory= [
        {title:'Egyéni előadók', presentations: invidualEvents},
        {title: 'Panelbeszélgetések', presentations: teamEvents}
    ]
    return (
    <>

        <CenterHero
            url={'/benefitshare/img/headerbg3.jpg'}
            megaphone={'Shaping success, sharing great ideas'}
            titles={['Programok']}
        ></CenterHero>
        <DetailedEvents title={"Program"} description={'Alább tájékozódhatsz az előadókról és a programokról'} events={eventsByCategory}></DetailedEvents>
        <Events title={"2025 SHARE Program"} description={''} events={eventsByCategory}></Events>
        <TicketHero titles={["Sharing ideas, shaping success.Big ideas for happy employees."]} megaphone={"Let's make something great work together."}>
            <PrimaryButton href={'/jegyek'} primaryText={'Jegy vásárlása'} secondaryText={"Biztosítsd a helyedet"}></PrimaryButton>
        </TicketHero>
        <Footer></Footer>
    </>
    )
}

export async function EventsLoader(){
    try {
        const response = await API.rest(Entities.event, "GET"); // Várjuk meg az API választ
        return {
            events: response,
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { events: []}; // Hiba esetén üres tömböt adunk vissza
    }
}